import React, { useState } from 'react';

const ACCENT = '#e71204';

const routesData = [
  {
    city: 'Chennai',
    label: 'Chennai One Way Cabs',
    routes: [
      { from: 'Chennai', to: 'Coimbatore', label: 'Chennai to Coimbatore taxi' },
      { from: 'Chennai', to: 'Bangalore', label: 'Chennai to Bangalore taxi' },
      { from: 'Chennai', to: 'Madurai', label: 'Chennai to Madurai taxi' },
      { from: 'Chennai', to: 'Trichy', label: 'Chennai to Trichy taxi' },
      { from: 'Chennai', to: 'Salem', label: 'Chennai to Salem taxi' },
      { from: 'Chennai', to: 'Pondicherry', label: 'Chennai to Pondicherry taxi' },
      { from: 'Chennai', to: 'Tirunelveli', label: 'Chennai to Tirunelveli taxi' },
      { from: 'Chennai', to: 'Rameshwaram', label: 'Chennai to Rameshwaram taxi' },
      { from: 'Chennai', to: 'Vellore', label: 'Chennai to Vellore taxi' },
      { from: 'Chennai', to: 'Thanjavur', label: 'Chennai to Thanjavur taxi' },
      { from: 'Chennai', to: 'Tirupati', label: 'Chennai to Tirupati taxi' },
    ]
  },
  {
    city: 'Coimbatore',
    label: 'Coimbatore One Way Cabs',
    routes: [
      { from: 'Coimbatore', to: 'Chennai', label: 'Coimbatore to Chennai taxi' },
      { from: 'Coimbatore', to: 'Bangalore', label: 'Coimbatore to Bangalore taxi' },
      { from: 'Coimbatore', to: 'Madurai', label: 'Coimbatore to Madurai taxi' },
      { from: 'Coimbatore', to: 'Trichy', label: 'Coimbatore to Trichy taxi' },
      { from: 'Coimbatore', to: 'Salem', label: 'Coimbatore to Salem taxi' },
      { from: 'Coimbatore', to: 'Pondicherry', label: 'Coimbatore to Pondicherry taxi' },
      { from: 'Coimbatore', to: 'Tirunelveli', label: 'Coimbatore to Tirunelveli taxi' },
      { from: 'Coimbatore', to: 'Rameshwaram', label: 'Coimbatore to Rameshwaram taxi' },
      { from: 'Coimbatore', to: 'Vellore', label: 'Coimbatore to Vellore taxi' },
      { from: 'Coimbatore', to: 'Thanjavur', label: 'Coimbatore to Thanjavur taxi' },
      { from: 'Coimbatore', to: 'Tirupati', label: 'Coimbatore to Tirupati taxi' },
    ]
  },
  {
    city: 'Trichy',
    label: 'Trichy One Way Cabs',
    routes: [
      { from: 'Trichy', to: 'Coimbatore', label: 'Trichy to Coimbatore taxi' },
      { from: 'Trichy', to: 'Bangalore', label: 'Trichy to Bangalore taxi' },
      { from: 'Trichy', to: 'Madurai', label: 'Trichy to Madurai taxi' },
      { from: 'Trichy', to: 'Chennai', label: 'Trichy to Chennai taxi' },
      { from: 'Trichy', to: 'Salem', label: 'Trichy to Salem taxi' },
      { from: 'Trichy', to: 'Pondicherry', label: 'Trichy to Pondicherry taxi' },
      { from: 'Trichy', to: 'Tirunelveli', label: 'Trichy to Tirunelveli taxi' },
      { from: 'Trichy', to: 'Rameshwaram', label: 'Trichy to Rameshwaram taxi' },
      { from: 'Trichy', to: 'Vellore', label: 'Trichy to Vellore taxi' },
      { from: 'Trichy', to: 'Erode', label: 'Trichy to Erode taxi' },
      { from: 'Trichy', to: 'Tirupati', label: 'Trichy to Tirupati taxi' },
    ]
  },
  {
    city: 'Madurai',
    label: 'Madurai One Way Cabs',
    routes: [
      { from: 'Madurai', to: 'Coimbatore', label: 'Madurai to Coimbatore taxi' },
      { from: 'Madurai', to: 'Bangalore', label: 'Madurai to Bangalore taxi' },
      { from: 'Madurai', to: 'Chennai', label: 'Madurai to Chennai taxi' },
      { from: 'Madurai', to: 'Trichy', label: 'Madurai to Trichy taxi' },
      { from: 'Madurai', to: 'Salem', label: 'Madurai to Salem taxi' },
      { from: 'Madurai', to: 'Pondicherry', label: 'Madurai to Pondicherry taxi' },
      { from: 'Madurai', to: 'Tirunelveli', label: 'Madurai to Tirunelveli taxi' },
      { from: 'Madurai', to: 'Rameshwaram', label: 'Madurai to Rameshwaram taxi' },
      { from: 'Madurai', to: 'Vellore', label: 'Madurai to Vellore taxi' },
      { from: 'Madurai', to: 'Thanjavur', label: 'Madurai to Thanjavur taxi' },
      { from: 'Madurai', to: 'Tirupati', label: 'Madurai to Tirupati taxi' },
    ]
  },
  {
    city: 'Bangalore',
    label: 'Bangalore One Way Cabs',
    routes: [
      { from: 'Bangalore', to: 'Coimbatore', label: 'Bangalore to Coimbatore taxi' },
      { from: 'Bangalore', to: 'Chennai', label: 'Bangalore to Chennai taxi' },
      { from: 'Bangalore', to: 'Madurai', label: 'Bangalore to Madurai taxi' },
      { from: 'Bangalore', to: 'Trichy', label: 'Bangalore to Trichy taxi' },
      { from: 'Bangalore', to: 'Salem', label: 'Bangalore to Salem taxi' },
      { from: 'Bangalore', to: 'Pondicherry', label: 'Bangalore to Pondicherry taxi' },
      { from: 'Bangalore', to: 'Tirunelveli', label: 'Bangalore to Tirunelveli taxi' },
      { from: 'Bangalore', to: 'Rameshwaram', label: 'Bangalore to Rameshwaram taxi' },
      { from: 'Bangalore', to: 'Vellore', label: 'Bangalore to Vellore taxi' },
      { from: 'Bangalore', to: 'Thanjavur', label: 'Bangalore to Thanjavur taxi' },
      { from: 'Bangalore', to: 'Tirupati', label: 'Bangalore to Tirupati taxi' },
    ]
  },
  {
    city: 'Pondicherry',
    label: 'Pondicherry One Way Cabs',
    routes: [
      { from: 'Pondicherry', to: 'Coimbatore', label: 'Pondicherry to Coimbatore taxi' },
      { from: 'Pondicherry', to: 'Bangalore', label: 'Pondicherry to Bangalore taxi' },
      { from: 'Pondicherry', to: 'Madurai', label: 'Pondicherry to Madurai taxi' },
      { from: 'Pondicherry', to: 'Trichy', label: 'Pondicherry to Trichy taxi' },
      { from: 'Pondicherry', to: 'Salem', label: 'Pondicherry to Salem taxi' },
      { from: 'Pondicherry', to: 'Chennai', label: 'Pondicherry to Chennai taxi' },
      { from: 'Pondicherry', to: 'Tirunelveli', label: 'Pondicherry to Tirunelveli taxi' },
      { from: 'Pondicherry', to: 'Rameshwaram', label: 'Pondicherry to Rameshwaram taxi' },
      { from: 'Pondicherry', to: 'Vellore', label: 'Pondicherry to Vellore taxi' },
      { from: 'Pondicherry', to: 'Thanjavur', label: 'Pondicherry to Thanjavur taxi' },
      { from: 'Pondicherry', to: 'Tirupati', label: 'Pondicherry to Tirupati taxi' },
    ]
  },
  {
    city: 'Salem',
    label: 'Salem One Way Cabs',
    routes: [
      { from: 'Salem', to: 'Coimbatore', label: 'Salem to Coimbatore taxi' },
      { from: 'Salem', to: 'Bangalore', label: 'Salem to Bangalore taxi' },
      { from: 'Salem', to: 'Madurai', label: 'Salem to Madurai taxi' },
      { from: 'Salem', to: 'Trichy', label: 'Salem to Trichy taxi' },
      { from: 'Salem', to: 'Chennai', label: 'Salem to Chennai taxi' },
      { from: 'Salem', to: 'Pondicherry', label: 'Salem to Pondicherry taxi' },
      { from: 'Salem', to: 'Tirunelveli', label: 'Salem to Tirunelveli taxi' },
      { from: 'Salem', to: 'Rameshwaram', label: 'Salem to Rameshwaram taxi' },
      { from: 'Salem', to: 'Vellore', label: 'Salem to Vellore taxi' },
      { from: 'Salem', to: 'Thanjavur', label: 'Salem to Thanjavur taxi' },
      { from: 'Salem', to: 'Tirupati', label: 'Salem to Tirupati taxi' },
    ]
  },
  {
    city: 'Vellore',
    label: 'Vellore One Way Cabs',
    routes: [
      { from: 'Vellore', to: 'Coimbatore', label: 'Vellore to Coimbatore taxi' },
      { from: 'Vellore', to: 'Bangalore', label: 'Vellore to Bangalore taxi' },
      { from: 'Vellore', to: 'Madurai', label: 'Vellore to Madurai taxi' },
      { from: 'Vellore', to: 'Trichy', label: 'Vellore to Trichy taxi' },
      { from: 'Vellore', to: 'Salem', label: 'Vellore to Salem taxi' },
      { from: 'Vellore', to: 'Pondicherry', label: 'Vellore to Pondicherry taxi' },
      { from: 'Vellore', to: 'Tirunelveli', label: 'Vellore to Tirunelveli taxi' },
      { from: 'Vellore', to: 'Rameshwaram', label: 'Vellore to Rameshwaram taxi' },
      { from: 'Vellore', to: 'Chennai', label: 'Vellore to Chennai taxi' },
      { from: 'Vellore', to: 'Thanjavur', label: 'Vellore to Thanjavur taxi' },
      { from: 'Vellore', to: 'Erode', label: 'Vellore to Erode taxi' },
    ]
  },
];

/**
 * AllPopularRoutes Component
 *
 * Props:
 *   onRouteSelect: function({ from, to }) — called when user clicks a route
 *                  Use this to autofill the booking form on the same page.
 *
 * Usage in HeroBookingSection or parent:
 *   <AllPopularRoutes onRouteSelect={({ from, to }) => { setPickup(from); setDrop(to); }} />
 */
const AllPopularRoutes = ({ onRouteSelect }) => {
  const [expandedCity, setExpandedCity] = useState(null);
  const [toast, setToast] = useState(null);

  const handleRouteClick = (route) => {
    if (onRouteSelect) {
      onRouteSelect({ from: route.from, to: route.to });
    }
    // Show toast feedback
    setToast(`${route.from} → ${route.to}`);
    setTimeout(() => setToast(null), 2500);

    // Scroll to top of page (where booking form is)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleCity = (city) => {
    setExpandedCity(prev => prev === city ? null : city);
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      {/* Toast notification */}
      {toast && (
        <div style={{
          position: 'fixed', bottom: '24px', left: '50%',
          transform: 'translateX(-50%)',
          background: '#1a1a1a', color: '#fff',
          padding: '12px 24px', borderRadius: '40px',
          fontSize: '14px', fontWeight: 600,
          zIndex: 9999,
          boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          display: 'flex', alignItems: 'center', gap: '10px',
          animation: 'fadeInUp 0.3s ease'
        }}>
          <span style={{
            width: '8px', height: '8px', borderRadius: '50%',
            background: ACCENT, flexShrink: 0,
            boxShadow: `0 0 6px ${ACCENT}`
          }} />
          Route filled: {toast}
        </div>
      )}

      {/* ── DESKTOP UI ── */}
      <div className="apr-desktop">
        <div style={{
          background: '#111827',
          padding: '64px 24px',
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            {/* Heading */}
            <h2 style={{
              textAlign: 'center',
              color: '#ffffff',
              fontSize: '36px',
              fontWeight: 800,
              marginBottom: '48px',
              letterSpacing: '-0.5px'
            }}>
              All Popular Routes
            </h2>

            {/* Routes Table */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
              {routesData.map((cityGroup, idx) => (
                <div key={cityGroup.city} style={{
                  display: 'grid',
                  gridTemplateColumns: '220px 1fr',
                  borderBottom: idx < routesData.length - 1 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                  padding: '20px 0',
                  alignItems: 'start',
                  gap: '24px'
                }}>
                  {/* City label */}
                  <div style={{
                    color: '#ffffff',
                    fontSize: '15px',
                    fontWeight: 700,
                    paddingTop: '2px',
                    letterSpacing: '0.1px'
                  }}>
                    {cityGroup.label}
                  </div>

                  {/* Routes */}
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0',
                    alignItems: 'center',
                    lineHeight: '2',
                  }}>
                    {cityGroup.routes.map((route, rIdx) => (
                      <span key={rIdx} style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <button
                          onClick={() => handleRouteClick(route)}
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: '2px 4px',
                            cursor: 'pointer',
                            color: 'rgba(255,255,255,0.75)',
                            fontSize: '13.5px',
                            fontWeight: 400,
                            transition: 'color 0.15s ease',
                            borderRadius: '4px',
                            lineHeight: 'inherit',
                            textDecoration: 'none',
                          }}
                          onMouseEnter={e => {
                            e.currentTarget.style.color = ACCENT;
                            e.currentTarget.style.textDecoration = 'underline';
                          }}
                          onMouseLeave={e => {
                            e.currentTarget.style.color = 'rgba(255,255,255,0.75)';
                            e.currentTarget.style.textDecoration = 'none';
                          }}
                          title={`Click to book: ${route.from} to ${route.to}`}
                        >
                          {route.label}
                        </button>
                        {rIdx < cityGroup.routes.length - 1 && (
                          <span style={{ color: 'rgba(255,255,255,0.25)', margin: '0 4px', fontSize: '13px' }}>|</span>
                        )}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── MOBILE UI ── */}
      <div className="apr-mobile">
        <div style={{
          background: '#ffffff',
          borderRadius: '0',
        }}>
          {routesData.map((cityGroup, idx) => (
            <div
              key={cityGroup.city}
              style={{
                borderBottom: '1px solid #f0f0f0',
              }}
            >
              {/* Accordion Header */}
              <button
                onClick={() => toggleCity(cityGroup.city)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '18px 20px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                <span style={{
                  fontSize: '15px',
                  fontWeight: 600,
                  color: '#1a1a1a',
                }}>
                  {cityGroup.city} one way cabs
                </span>
                <span style={{
                  color: ACCENT,
                  fontSize: '20px',
                  fontWeight: 700,
                  transform: expandedCity === cityGroup.city ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.25s ease',
                  lineHeight: 1,
                  display: 'flex',
                  alignItems: 'center',
                }}>
                  ⌄
                </span>
              </button>

              {/* Accordion Content */}
              {expandedCity === cityGroup.city && (
                <div style={{
                  padding: '0 20px 16px',
                  animation: 'expandDown 0.2s ease',
                }}>
                  {cityGroup.routes.map((route, rIdx) => (
                    <button
                      key={rIdx}
                      onClick={() => handleRouteClick(route)}
                      style={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        background: 'none',
                        border: 'none',
                        padding: '10px 12px',
                        marginBottom: '4px',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: 500,
                        transition: 'background 0.15s, color 0.15s',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.background = '#fff5f4';
                        e.currentTarget.style.color = ACCENT;
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.background = 'none';
                        e.currentTarget.style.color = '#444';
                      }}
                    >
                      <span style={{
                        width: '6px', height: '6px',
                        borderRadius: '50%',
                        background: ACCENT,
                        flexShrink: 0,
                        opacity: 0.6,
                      }} />
                      {route.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .apr-desktop { display: block; }
        .apr-mobile  { display: none;  }

        @media (max-width: 767px) {
          .apr-desktop { display: none !important;  }
          .apr-mobile  { display: block !important; }
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translate(-50%, 16px); }
          to   { opacity: 1; transform: translate(-50%, 0);    }
        }
        @keyframes expandDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0);    }
        }
      `}</style>
    </div>
  );
};

export default AllPopularRoutes;